import React, { useEffect } from 'react';
import { useLegislation } from '../../../hooks/useLegislation';
import styles from '../../../styles/EducationHub.module.css';
import LoadingSpinner from 'components/common/LoadingSpinner';

const LegislationSection: React.FC = () => {
  const { grouped, loading, error, fetchLinks } = useLegislation();

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  if (loading) {
    return (
      <LoadingSpinner />
    );
  }

  if (error) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>⚠️</div>
        <h3 className={styles.emptyTitle}>Failed to Load</h3>
        <p className={styles.emptyDescription}>{error}</p>
      </div>
    );
  }

  if (grouped.length === 0) {
    return (
      <div className={styles.emptyState}>
        <div className={styles.emptyIcon}>⚖️</div>
        <h3 className={styles.emptyTitle}>No Legislation Content Yet</h3>
        <p className={styles.emptyDescription}>
          Legislation links and references will appear here once added by an administrator.
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.legislationContent}>
        {grouped.map(category => (
          <section key={category.categoryId ?? '__none__'} className={styles.legislationSection}>
            {category.categoryName && (
              <h2 className={styles.legislationHeading}>{category.categoryName}</h2>
            )}

            {/* Links that belong directly to the category (no subcategory) */}
            {category.directLinks.length > 0 && (
              <div className={styles.legislationSubsection}>
                <ul className={styles.legislationLinks}>
                  {category.directLinks.map(link => (
                    <li key={link.id}>
                      {link.bodyText && (
                        <p className={styles.legislationText}>{link.bodyText}</p>
                      )}
                      <a href={link.linkUrl} target="_blank" rel="noopener noreferrer">
                        {link.linkLabel}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Subcategory groups */}
            {category.subcategories.map(sub => (
              <div key={sub.subcategoryId} className={styles.legislationSubsection}>
                <h3 className={styles.legislationSubheading}>{sub.subcategoryName}</h3>
                <ul className={styles.legislationLinks}>
                  {sub.links.map(link => (
                    <li key={link.id}>
                      {link.bodyText && (
                        <p className={styles.legislationText}>{link.bodyText}</p>
                      )}
                      <a href={link.linkUrl} target="_blank" rel="noopener noreferrer">
                        {link.linkLabel}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

export default LegislationSection;
